const prettyPrintKey = (key) => {

  if(key === 'tc_temp_above') {
    return "Probe Temp Alert Mode Above";
  } else if(key === 'tc_temp_below') {
    return 'Probe Temp Alert Mode Below';
  }

  if(key === 'TC_TYPE') {
    return "Probe Type";
  }

  if(key === 'TC_SKIN') {
    return "Probe Application";
  }

  if(key === 'PWR_M') {
    return "USB Power Mode";
  }

  let name = key;
  name = name.replaceAll('-', ' ');
  name = name.replaceAll('_', ' ');
  name = name.replaceAll('__', ' ');
  name = name.replaceAll('--', ' ');
  name = name[0].toUpperCase() + name.slice(1);;

  return name;

};

export default prettyPrintKey;